import { graphql } from 'relay-runtime';

export const UNLINK_MUTATION = graphql`
  mutation UnlinkMutation($aaid: String!) {
    unified {
      account {
        unlinkAccount(aaid: $aaid) {
          errors {
            extensions {
              errorType
              statusCode
            }
            code
            message
          }
          message
          success
        }
      }
    }
  }
`;
